import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LanguageManagementService } from '../../../service/language-management.service';
import { KeyValues3, LocalService, Status, TriggeredEvent } from '../../../service/local.service';
import { ProfileManagementService } from '../../../service/profile-management.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-associated-accounts',
  templateUrl: './associated-accounts.component.html',
  styleUrls: ['./associated-accounts.component.scss']
})
export class AssociatedAccountsComponent implements OnInit {
  @Input() userOrBusinessId = ''; @Input() isUser: boolean = true; @Input() countryCode = '';
  lstSectionConfigKeys: string[] = ["associated_accts"]; items: KeyValues3[]; isShowBarCode = false;
  constructor(public localService: LocalService, private languageManagementService: LanguageManagementService, private activeModal: NgbActiveModal, private profileManagementService: ProfileManagementService, private router: Router) { }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.onLoad();
  }

  onLoad() {
    if (this.localService.getLoginAsCountryCode() != '') {
      this.profileManagementService.getAssociatedAccounts(this.localService.getLoginAsCountryCode(), this.userOrBusinessId, this.isUser).subscribe(result => {
        this.items = result;
      });
    } else {
      this.activeModal.close({ event: TriggeredEvent.Close });
    }
  }

  onPopupSave() {
    this.profileManagementService.blockUnblockAccounts(this.localService.getLoginAsCountryCode(), this.items, this.isUser).subscribe(result => {
      this.localService.showInformationByStatus(result.status);
      if (result.status == Status.Success) {
        this.activeModal.close({ event: TriggeredEvent.Ok });
      }
    });
  }

  onAction(index, key?: string) {
    switch (index) {
      case 1: {
        this.items.forEach(x => x.isSelected = true);
      } break;
      case 2: {
        this.items.forEach(x => x.isSelected = false);
      } break;
      case 3: {
        this.isShowBarCode = !this.isShowBarCode;
      } break;
      case 4: {
        if (this.isUser) {
          this.router.navigate(['/seller' + this.localService.basicParamsString, key]);
        } else {
          this.router.navigate(['/user', this.localService.getLoginAsCountryCode(), key, 1]);
        }
        this.activeModal.close({ event: TriggeredEvent.Close });
      } break;
    }
  }

}
